import { db } from '@/main';
import moment from 'moment'

const state = {
    todo : []
}

// getters
const getters = {

}

// mutations
const mutations = {
    taskActive:(state,payload)=>{
        var updatestatus = "";
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.status == 'ACTIVE'){
                    updatestatus = 'INACTIVE'
                }
                else if(list.status == 'INACTIVE'){
                    updatestatus = 'ACTIVE'
                }
            }
        })

        const updateRef = db.collection('Notice').doc(payload);
        updateRef.update({ status:updatestatus })
    },

    tododelete:(state,payload)=>{
        db.collection('Notice').doc(payload).delete()
    },

    addtodo:(state, payload)=>
    {        
        if (payload.notice_link == null)payload.notice_link = ""
        if (payload.notice_image == null)payload.notice_image = ""

        if (payload.message_korean == null)payload.message_korean = ""
        if (payload.message_spanish == null)payload.message_spanish = ""
        if (payload.message_portuguese == null)payload.message_portuguese = ""
        if (payload.message_french == null)payload.message_french = ""
        if (payload.message_german == null)payload.message_german = ""
        if (payload.message_russian == null)payload.message_russian = ""

        db.collection('Notice').add({ 
                        
            market: payload.notice_market,
            versionCode: payload.notice_versionCode,
            deadline : payload.notice_deadline,
            link: payload.notice_link,
            image: payload.notice_image,

            message: 
            {
                english : payload.message_english,
                korean : payload.message_korean,
                spanish : payload.message_spanish,
                portuguese : payload.message_portuguese,
                french : payload.message_french,
                german : payload.message_german,
                russian : payload.message_russian                
            },             
               
            status : 'INACTIVE',
            created: new Date()
        })
    },

    retrieveTodos(state,todos){
        state.todo = todos
    }
 
};

// actions
const actions = {
    retrieveTodos:(context)=>{
        db.collection('Notice').get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                //tempTodos.push(doc.data());
                //tempTodos.push({ id:doc.id, title:doc.data().title, delete:doc.data().delete, status:doc.data().status, created:doc.data().created });
                
                tempTodos.push({ 
                    id:doc.id, 
                    market:doc.data().market, 
                    versionCode:doc.data().versionCode,      
                    deadline:moment(String(doc.data().deadline.toDate())).format('YYYY-MM-DD 23:59:59'),

                    link:doc.data().link,
                    image:doc.data().image, 
                    message:doc.data().message,   
                    status:doc.data().status,                     
                    created:moment(String(doc.data().created.toDate())).format('YYYY-MM-DD hh:mm')
                    
                });                
            })

            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.created.seconds - b.created.seconds
            })

            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    taskActive:(context, payload) => {
        context.commit('taskActive',payload)
    },
    alltaskcomplete:(context,payload) => {
        context.commit('alltaskcomplete',payload)
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    },
    addtodo:(context, payload) => {
        context.commit('addtodo', payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}